export enum URL {
  CHECKOUT = '/v2/consumer/checkout',
  LOGIN = '/v1/consumer/login',
  APPLICATIONS = '/v1/applications',
  APPS = '/v2/applications',
  HOME = '/home',
  VERIFY = '/v2/consumer/login/otp',
  VERIFY_DOB = '/v1/consumer/mfa/dob',
  VERIFY_PIN = '/v1/consumer/mfa/pin',
  V3_APPLICATION_SC = '/v3/application/sc',
  V2_APPLICATION_SC = '/v2/application/sc',
  APPLICATION_EVALUATION = '/v2/application',
  PROMPT = '/v2/application/prompt',
  CHECK_APPLICATION = '/checkApplication',
  VALIDATE_PARTNER_AUTH = '/partners/v1/auth/validate', //TODO:[WS] placeholder, endpoint not finalized
  HH_WEBSITE = 'https://horizonhobby.com',
  HEB_WEBSITE = 'https://heb.com',
  CM_WEBSITE = 'https://www.centralmarket.com/',
  TRANSUNION = 'https://www.transunion.com/',
  IMPRINT_TOS = 'https://www.imprint.co/terms-of-service.pdf',
  ARTICLE_LINK = 'https://www.transunion.com/blog/credit-advice/what-should-i-do-after-i-freeze-my-credit',
  OFFER = '/offer',
  ACCEPT = '/accept',
  SUBSCRIBE = '/v1/subscribe',
  CARD_ENDPOINT = '/v1/card',
  ANALYTICS = '/v1/analytics',
  LANGUAGE = '/v1/consumer/language',
  PAYMENT_CONSENT = 'https://imprint.co/legal/payment-consent',
  CONSUMER_LOGOUT = '/v1/consumer/logout',
  CREATE_PIN = '/v1/consumer/pin',
  RESET_PIN = '/v1/account/pin',
  HOME_API = '/v2/home',
  PARTNER_METADATA = '/partners/v1/metadata',
  LOAD_PRODUCT_ACCOUNT = '/v2/productAccount',
  CUSTOMER_SESSION = '/v1/sessions',
}

export enum RESPONSE_CODE {
  NO_CONTENT = 204,
}

export enum SIGN_UP_ELIGIBILITY_STATUS {
  ELIGIBLE = 'eligible',
  REJECTED_WITHIN_COOLDOWN_WINDOW = 'rejectedWithinCooldownWindow',
  REJECTED_AFTER_COOLDOWN_WINDOW = 'rejectedAfterCooldownWindow',
  REAPPLY = 'reapply',
  FROZEN = 'frozen',
}

export enum CHECKOUT_STATUS {
  NEW_USER = 'NEW_USER',
  PRESIGNUP = 'PRESIGNUP',
}

export enum CHECKOUT_APPLICATION_STATE {
  INITIALIZED = 'INITIALIZED',
  PENDING = 'PENDING',
  PREAPPROVED = 'PREAPPROVED',
  FROZEN = 'FROZEN',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
  APPROVED = 'APPROVED',
}
